import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { UTILS } from "utils";
function useShowUserInfoModal() {
  const { brandInfo } = useSelector((state) => state?.brandStorageReducer);
  const { currentUser: reduxUser } = useSelector((state) => state?.register);
  const [currentUser, setUser] = useState({});
  const [isOpenUserInfoModal, setUserInfoModal] = useState(false);

  const setUserInfo = () => {
    const user = UTILS.getCurrentUser(brandInfo?.brand?._id);
    console.log("user", user);
    if(!user) return;
    if (!user?.user?.name || !user?.user?.phoneNumber) {
      setUser(user);
      setUserInfoModal(true);
    } else {
      setUser({});
      setUserInfoModal(false);
    }
  };
  useEffect(() => {
    if (brandInfo?.brand?._id) {
      setUserInfo();
    }
  }, [brandInfo?.brand?._id, reduxUser?.user?.name, reduxUser?.user?.phoneNumber]);
  
  return {
    currentUser,
    setUserInfo,
    isOpenUserInfoModal,
    setUserInfoModal,
  };
}

export default useShowUserInfoModal;
